import React from 'react';
import ReactDOM from 'react-dom';
import { i18nIntl } from '../../lib/ep';

import { injectIntl } from 'react-intl';

const SaveFeedback = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	let element = document.getElementById('gui_feedbacks');
	if(element == null) {
		element = document.createElement('div');
		element.id = 'gui_feedbacks';
		document.body.appendChild(element);
		element = document.getElementById('gui_feedbacks');
	}

	return ReactDOM.createPortal(
		<>
			<div class="data_saved">
				<span id="just-saved" class="knk-check">{i18n("Changes saved")}</span>
			</div>

			<div class="data_saved_error">
				<span id="just-saved-error" class="knk-alert">{i18n("There were errors")}</span>
			</div>
		</>,
		element,
	);
};

export default injectIntl(SaveFeedback);